type Fields = {
  otherDesc: string;
  otherName: string;
  sponsorshipAmount: number;
};

type Visible = Record<'otherDesc' | 'otherName' | 'sponsorshipAmount', boolean>;

export function getPageStatus(fields: Fields): {
  complete: boolean;
  visible: Visible;
} {
  const { otherDesc, otherName, sponsorshipAmount } = fields;

  const complete: boolean = (() => {
    if (otherDesc === '') return false;
    if (otherName === '') return false;
    if (sponsorshipAmount === 0) return false;

    return true;
  })();

  const visible: Visible = {
    otherDesc: true,
    otherName: true,
    sponsorshipAmount: true,
  };

  return {
    complete,
    visible,
  };
}
